import React from 'react';
import { motion } from 'framer-motion';
import { UserPlus } from 'lucide-react';

interface PersonnelHeaderProps {
  onInviteClick: () => void;
}

const PersonnelHeader: React.FC<PersonnelHeaderProps> = React.memo(({ onInviteClick }) => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Προσωπικό</h1>
          <p className="mt-2 text-gray-600">Διαχειριστείτε τα μέλη και το προσωπικό της ομάδας σας</p>
        </div>
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={onInviteClick}
          className="flex items-center gap-2 rounded-xl bg-blue-600 px-6 py-3 text-white shadow-lg transition-all hover:bg-blue-700"
        >
          <UserPlus className="h-5 w-5" />
          Πρόσκληση Μέλους
        </motion.button>
      </div>
    </div>
  );
});

PersonnelHeader.displayName = 'PersonnelHeader';

export default PersonnelHeader;
